import { render, staticRenderFns } from "./BusCheckin.vue?vue&type=template&id=0ae3f7fb&scoped=true&"
import script from "./BusCheckin.vue?vue&type=script&lang=js&"
export * from "./BusCheckin.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ae3f7fb",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard})
